<template>
  <!-- https://3.swiper.com.cn/demo/pcSlide/ -->
  <div class="cmp-swiper" :class="{'mobile':_isMobile, 'pc': !_isMobile}">
    <div class="cmp-swiper-wrap">
      <div class="gallery-wrap">
        <div class="swiper-container gallery-top" ref="myGalleryTop">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in detailData.images" :key="i">
              <div class="pic_bg" :style="{backgroundImage:'url(' + item + ')'}"></div>
              <img :src="item||''" :onerror="$store.state.app.defaultErrorImg" preview="0" preview-text="" alt="">
            </div>
            <!-- 静态数据 勿删 start -->
            <!-- <div class="swiper-slide">
              <div class="pic_bg" style="background: url('/files/museumWeb//static/upload/e7520b36-4e61-40dd-875c-af46732409ec.png');"></div>
              <img src="@images/1.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/2.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/3.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/4.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/5.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/6.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/3.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/4.jpg" preview="0" preview-text="" alt="">
            </div> -->
            <!-- 静态数据 误删 end -->
          </div>

          <div class="icon-3d-box g-pointer" @click="openDetail" v-if="detailData.threeDimensionalInfo">
            <i class="icon-3d"></i>
          </div>
        </div>

        <div class="pic-info g-border-box m-font-4">
            <div class="g-border">
              <span class="g-bor-dec g-bor-dec-1"></span>
              <span class="g-bor-dec g-bor-dec-2"></span>
              <span class="g-bor-dec g-bor-dec-3"></span>
              <span class="g-bor-dec g-bor-dec-4"></span>
  
              <p class="collect-title m-font-2">{{detailData.name}}</p>
              <div class="m-line mt-5 mb-3" v-if="!_isMobile"></div>
              <div class="des-box">
                <p>年代：{{detailData.year}}</p>
                <p>类别：{{detailData.type}}</p>
                <p>级别：{{detailData.level}}</p>
                <p>质地：{{detailData.texture}}</p>
                <p>尺寸：{{detailData.size}}</p>
              </div>
  
              <div class="btn-box">
                <!-- <a class="btn-digital g-btn-level-1" @click="handleMax">查看高清大图</a> -->
                <!-- <span class="box-like" v-if="!_isMobile">
                  <i class="icon-like" :class="{'active': isLike}" @click.stop="handleLike"></i>
                  {{detailData.loveNum}}人喜欢
                </span> -->
              </div>
            </div>
        </div>
      </div>

      <div class="thumbs-wrap" v-show="!_isMobile">
        <div class="swiper-container gallery-thumbs" ref="myThumb">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in detailData.images" :key="i">
              <div class="pic_bg" :style="{backgroundImage:'url(' + item + ')'}"></div>
              <img :src="item||''" :onerror="$store.state.app.defaultErrorImg" alt="">
            </div>

            <!-- 静态数据 误删 start -->
            <!-- <div class="swiper-slide active">
              <img src="@images/1.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/2.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/3.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/4.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/5.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/6.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/3.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/4.jpg" alt="">
            </div> -->
            <!-- 静态数据 误删 end -->
          </div>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-prev swiper-button-white" @click.stop="clickPrev"></div>
        <div class="swiper-button-next swiper-button-white" @click.stop="clickNext"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  // import 'swiper/swiper-bundle.css';  // 6以上 部分api有问题 eg:slidesPerColumn无效
  export default {
    props: {

    },
    // watch: {
    //   $route() {
    //     this.activeMenu = '/' + this.$route.path.split('/')[1]
    //     this.selectedItem = this.menuList.findIndex(item => item.url === this.activeMenu)
    //   }
    // },
    data() {
      return {
        detailData: {},
        galleryTop: '',
        galleryThumbs: '',
        isLike: ''
      }
    },
    methods: {
      init(detailData) {
        console.log(222, detailData)

        this.isLike = localStorage.getItem('tj_like_'+detailData.id)
        this.detailData = detailData
        let vm = this
        this.$nextTick(() => {
          this.galleryTop = new Swiper('.gallery-top', {
            onSlideChangeStart: function() {
              if(!vm._isMobile && vm.detailData.images.length > 1) {
                vm.updateNavPosition()
              }
            }
          })
          this.galleryThumbs = new Swiper('.gallery-thumbs', {
            slidesPerView: 'auto',
            allowTouchMove: false,
            onInit: function() {
              // 默认第一个加上active
              vm.$refs.myThumb.getElementsByClassName('swiper-slide')[0].classList.add('active')
            },
            onTap: function() {
              vm.galleryTop.slideTo(vm.galleryThumbs.clickedIndex)
            }
          })
  
          this.$previewRefresh()
        })
      },
      openDetail() {
        window.open(this.detailData.threeDimensionalInfo)
      },
      // 喜欢、点赞
      handleLike() {
        if(this.isLike) return

        this.$http
          .post('/collect/love', {
            id: this.detailData.id
          })
          .then(res => {
            if (res.success) {
              this.$notify('点赞成功')
              this.isLike = true
              localStorage.setItem('tj_like_'+this.detailData.id, true)
              this.$emit('refresh')
            } else {
              this.$notify(res.message)
            }
          })
      },
      handleMax() {
        console.log(this.$refs.myGalleryTop.getElementsByClassName('swiper-slide')[0].getElementsByTagName('img')[0])
        if(this.galleryTop) {
          let _index = this.galleryTop.activeIndex
          this.$refs.myGalleryTop.getElementsByClassName('swiper-slide')[_index].getElementsByTagName('img')[0].click()
        }
      },
      // 上一张
      clickPrev() {
        console.log(this.galleryTop.activeIndex)
        if (this.galleryTop.activeIndex == 0) {
          this.galleryTop.slideTo(this.galleryTop.slides.length - 1, 1000);
          return
        }
        this.galleryTop.slidePrev()
      },
      // 下一张
      clickNext() {
        if (this.galleryTop.activeIndex == this.galleryTop.slides.length - 1) {
          this.galleryTop.slideTo(0, 1000);
          return
        }
        this.galleryTop.slideNext()
      },
      updateNavPosition() {
        this.$refs.myThumb.getElementsByClassName('swiper-slide active')[0].classList.remove('active')
        this.$refs.myThumb.getElementsByClassName('swiper-slide')[this.galleryTop.activeIndex].classList.add('active')
        let activeNav = this.$refs.myThumb.getElementsByClassName('swiper-slide active')[0]
        let arr = this.$refs.myThumb.getElementsByClassName('swiper-slide')
        let activeNavIndex = 0 // 缩略图点击的index值
        for(let i = 0; i < arr.length; i++) {
          if(arr[i].className.includes('swiper-slide active')) {
            activeNavIndex = i
            break
          }
        }
        if (!activeNav.classList.contains('swiper-slide-visible')) {
          if (activeNavIndex > this.galleryThumbs.activeIndex) {
            // var thumbsPerNav = Math.floor(this.galleryThumbs.width / activeNav.offsetWidth) - 1
            // 保证后面有一张图可以显示出来
            // 第7(index为6)个的时候应该滑到第一个（5为缩略图显示个数-2）
            this.galleryThumbs.slideTo(activeNavIndex - 5)
          } else {
            this.galleryThumbs.slideTo(activeNavIndex)
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
.cmp-swiper-wrap {
  position: relative;
  // width: 800px;
  // height: 300px;
  .swiper-container {
    width: 100%;
    height: 460px;
    margin-left: auto;
    margin-right: auto;
  }
  .swiper-slide {
    width: 100%;
    // height: 100px;
    position: relative;
    background-size: cover;
    background-position: center;
  }
  .gallery-wrap {
    display: flex;
    .gallery-top {
      position: relative;
      flex: 1;
      height: 460px;
      .swiper-slide {
        // background: url(~@images/swiper-bg.png) no-repeat center center;
        // background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .pic_bg {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          filter: blur(50px);
          /* transform: scale(2); */
          background-position: center center;
          background-size: 200% 200%;
        }
        img {
          position: relative;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .icon-3d-box {
        position: absolute;
        right: 40px;
        bottom: 40px;
        z-index: 3;
        width: 60px;
        height: 60px;
        border-radius: 100%;
        background: rgba($color: #000000, $alpha: 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        .icon-3d {
          display: inline-block;
          width: 40px;
          height: 40px;
          background: url(~@images/icon-3d.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
    .pic-info {
      position: relative;
      width: 680px;
      color: #3D3D3D;
      padding: 40px;
      box-sizing: border-box;
      // background: #fff;
      background: url(~@images/card-collect-bg.png) no-repeat center center;
      background-size: 100% 100%;
      .collect-title {
        color: $primary;
        &:after {
          margin: 20px 0 40px;
          content: '';
          display: block;
          width: 600px;
          height: 6px;
          background: url(~@images/detail-line.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
      .des-box {
        margin-top: 20px;
        p {
          margin-bottom: 24px;
        }
      }
      .btn-box {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        box-sizing: border-box;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 30px;
        cursor: pointer;
        
      }
    }
    .box-like {
      display: flex;
      align-items: center;
      .icon-like {
        margin-right: 5px;
        width: 16px;
        height: 15px;
        background: url(~@images/icon_like.png) no-repeat center center;
        background-size: 100% 100%;
        &.active {
          background: url(~@images/icon_like_active.png) no-repeat center center;
          background-size: 100% 100%;
        } 
      }
    }
  }
  .gallery-thumbs {
    height: 100px;
    width: 100%;
    padding: 10px 2px;
    // width: 1200px;
    // margin: 0 auto;
    box-sizing: border-box;
  }
  .gallery-thumbs .swiper-slide {
    width: 160px;
    // width: 25%;
    height: 100%;
    // opacity: 0.4;
    border: solid 3px transparent;
    margin-right: 6px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: #e5e5e5;
    }
  }
  // .gallery-thumbs .swiper-slide-active {
  .gallery-thumbs .active {
    opacity: 1;
    border: solid 3px $primary;
    // border: solid 3px #d6a884;
    box-shadow: 0px 2px 3px 0px rgba(176,172,167,0.90); 
  }
  .thumbs-wrap {
    position: relative;
    .swiper-button-prev {
      width: 48px;
      height: 48px;
      position: absolute;
      left: 0;
      top: 50%;
      background: url(~@images/btn-prev.png) no-repeat center center;
      background-size: 100%;
    }
    .swiper-button-next {
      width: 48px;
      height: 48px;
      position: absolute;
      right: 0;
      top: 50%;
      background: url(~@images/btn-next.png) no-repeat center center;
      background-size: 100%;
    }
  }
}
</style>